import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/pc/Home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/pc/About.vue')
  },
  {
    path: '/technology',
    name: 'technology',
    component: () => import(/* webpackChunkName: "technology" */ '../views/pc/technology.vue')
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import(/* webpackChunkName: "contactUs" */ '../views/pc/contactUs.vue')
  },
  {
    path: '/public',
    name: 'public',
    component: () => import(/* webpackChunkName: "public" */ '../views/pc/public.vue')
  },
  {
    path: '/redBook',
    name: 'redBook',
    component: () => import(/* webpackChunkName: "redBook" */ '../views/pc/redBook.vue')
  },
  {
    path: '/medium',
    name: 'medium',
    component: () => import(/* webpackChunkName: "medium" */ '../views/pc/medium.vue')
  }
]

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes
// })

export default routes
